<p>wind-auth-register works!</p>
